module.exports = __webpack_public_path__ + "static/media/HighlightGood.e2e94334.png";